import React from 'react';
import './EnterpriseFeatures.css';
import Icons from './Icons';

const EnterpriseFeatures = () => {
  const features = [
    {
      id: 1,
      icon: Icons.AiDrivenLearning,
      title: 'AI-Driven Learning',
      description:
        'Personalized learning paths powered by artificial intelligence and machine learning algorithms.',
    },
    {
      id: 2,
      icon: Icons.AutomatedWorkflows,
      title: 'Automated Workflows',
      description:
        'Streamline enrollments, approvals, and compliance tracking with intelligent automation.',
    },
    {
      id: 3,
      icon: Icons.SkillsCompetencyManagement,
      title: 'Skills & Competency Management',
      description:
        'Map skills, identify gaps, and align learning with career development goals.',
    },
    {
      id: 4,
      icon: Icons.MultiTenantSupport,
      title: 'Multi-Tenant Support',
      description:
        'Manage multiple departments, locations, or organizations from a single platform.',
    },
    {
      id: 5,
      icon: Icons.HrmsIntegration,
      title: 'HRMS Integration',
      description:
        'Seamlessly sync with your existing HR systems, ERPs, and enterprise applications.',
    },
    {
      id: 6,
      icon: Icons.RealtimeAnalytics,
      title: 'Real-Time Analytics',
      description:
        'Comprehensive dashboards and insights to track learning progress and ROI.',
    },
    {
      id: 7,
      icon: Icons.AutomatedCourseCreation,
      title: 'Automated Course Creation',
      description:
        'Generate comprehensive courses automatically with AI-powered content structuring and organization.',
    },
    {
      id: 8,
      icon: Icons.AutomatedQuizGeneration,
      title: 'Automated Quiz Generation',
      description:
        'Create engaging quizzes automatically with intelligent question generation and difficulty levels.',
    },
    {
      id: 9,
      icon: Icons.AutomatedAssessments,
      title: 'Automated Assessments',
      description:
        'Build comprehensive assessments automatically with adaptive testing and performance tracking.',
    },
  ];

  return (
    <div className="landing-enterprise-wrapper">
      <div className="landing-enterprise-container">
        <div className="landing-enterprise-header">
          <h1>Everything You Need to Scale Learning</h1>
          <p className="landing-enterprise-subtitle">
            A comprehensive platform that combines the best features of leading LXP solutions with modern enterprise requirements.
          </p>
        </div>

        <div className="landing-enterprise-features-grid">
          {features.map((feature) => {
            const IconComponent = feature.icon;
            return (
              <div key={feature.id} className="landing-enterprise-feature-card">
                <div className="landing-enterprise-icon-wrapper">
                  <IconComponent className="landing-enterprise-feature-icon" />
                </div>
                <div className="landing-enterprise-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseFeatures;